var _path, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencilIconDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07706 14.923H2.11356L12.8271 4.2125L11.7876 3.173L1.07706 13.8895V14.923ZM0.153809 15.8462V13.4962L13.2116 0.412497C13.3037 0.329997 13.4055 0.266246 13.5168 0.221246C13.628 0.176246 13.7466 0.153748 13.8728 0.153748C13.9966 0.153748 14.1166 0.174414 14.2326 0.215747C14.3487 0.257247 14.46 0.324746 14.5663 0.418246L15.5876 1.44225C15.6812 1.54041 15.7477 1.64741 15.7871 1.76325C15.8266 1.87908 15.8463 1.996 15.8463 2.114C15.8463 2.24 15.8248 2.36083 15.7818 2.4765C15.739 2.59216 15.6736 2.6945 15.5858 2.7835L2.50381 15.8462H0.153809ZM12.2991 3.701L11.7876 3.173L12.8271 4.2125L12.2991 3.701Z",
    fill: "#BDBDBD"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 16,
    y2: 16,
    stroke: "#BDBDBD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIconDisabled);
export default __webpack_public_path__ + "static/media/pencil-icon-disabled.5b9fbfec895e9ed3a1f586b9a9068760.svg";
export { ForwardRef as ReactComponent };